import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getResponses } from '@/api/yahoo-response'
import IApiResponse from '@/types/api-response'
import IList from '@/types/list-result'
import IPagination from '@/types/pagination'

interface IYahooResponseState {
	loading: boolean
	responses: IYahooResponse[]
	pagination?: IPagination
}

export interface IYahooResponse {
	_id: string
    code: string
	url: string
	step: string
	customer_id: string
	created_at: string
	updated_at: string
	prev_step_id: string | null
	response: { [key: string]: any }
	request: { [key: string]: any }
    apiKey: { _id: string; name: string; description?: string }
    account: { display_name: string; username: string } | null
}

const initialState: IYahooResponseState = {
	loading: false,
	responses: [],
}

export const fetchResponses = createAsyncThunk<
	IApiResponse<IList<IYahooResponse>>,
	{
		params: { [key: string]: any }
		cb?: (r: IApiResponse<IList<IYahooResponse>>) => void
	}
>('system_log/fetch_system_logs', async ({ params, cb }) => {
	const result = await getResponses(params)
	if (typeof cb === 'function') {
		cb(result)
	}
	return result
})

const yahooResponseSlice = createSlice({
	name: 'yahoo_response',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchResponses.pending, (state) => {
				state.loading = true
			})
			.addCase(fetchResponses.fulfilled, (state, { payload }) => {
				state.loading = false
				state.pagination = payload.data!.pagination
				if (payload.success) {
					state.responses = payload.data!.records
				} else {
					state.responses = []
				}
			})
			.addCase(fetchResponses.rejected, (state) => {
				state.loading = false
			})
	},
})

export default yahooResponseSlice.reducer
